// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"67":"af491f34","564":"12f4a301","852":"e8691059","912":"f525a1fa","934":"b3ca9489","960":"8b224b48"}[chunkId] + ".css";
};